import React from "react";
import ReactCountryFlag from "react-country-flag";

export const GenericFlag = ({ code, height = '15px', width = '20px' }) => {
  return (
    <ReactCountryFlag
      countryCode={code}
      svg
      style={{
        width: width,
        height: height,
        borderRadius: '5px'
      }}
    />
  );
};